export function RedirectExternal({ path }) {
  window.location.replace(path);
  return <></>;
}
